module.exports = __webpack_public_path__ + "img/sort_size.b2ca2f27.svg";